import { ColumnConfig, formatCurrency, ITableCell, TableRowProps } from '@urbanx/agx-ui-components';
import dayjs from 'dayjs';
import { useMemo } from 'react';
import { ICommissionDiscrepancy } from 'types/rex';

const columnConfig = [
  { name: 'Agency Name', widthInfo: { percent: 12 } },
  { name: 'Agent Name', widthInfo: { percent: 10 } },
  { name: 'Property Address' },
  { name: 'Accepted Date', widthInfo: { percent: 9 } },
  { name: 'REX Sale Price', widthInfo: { percent: 9 } },
  { name: 'Autopilot Sale Price', widthInfo: { percent: 9 } },
  { name: 'REX Commission', widthInfo: { percent: 9 } },
  { name: 'Autopilot Commission', widthInfo: { percent: 9 } },
] satisfies ColumnConfig[];

const useCommissionDiscrepanciesTableConfig = (
  discrepancies: ICommissionDiscrepancy[]
): [ColumnConfig[], TableRowProps[]] => {
  const rows = useMemo(
    () =>
      discrepancies.map((discrepancy, index) => {
        const cells: ITableCell[] = [
          {
            columnConfig: columnConfig[0],
            children: discrepancy?.agencyName,
          },
          {
            columnConfig: columnConfig[1],
            children: discrepancy?.agentName,
          },
          {
            columnConfig: columnConfig[2],
            children: discrepancy?.propertyAddress,
          },
          {
            columnConfig: columnConfig[3],
            children: discrepancy?.acceptedDate
              ? dayjs(discrepancy.acceptedDate).format('DD/MM/YYYY')
              : '',
          },
          {
            columnConfig: columnConfig[4],
            children: discrepancy?.rexSalePrice ? formatCurrency(discrepancy.rexSalePrice, 2) : '',
          },
          {
            columnConfig: columnConfig[5],
            children: discrepancy?.autopilotSalePrice
              ? formatCurrency(discrepancy.autopilotSalePrice, 2)
              : '',
          },
          {
            columnConfig: columnConfig[6],
            children: discrepancy?.rexCommission
              ? formatCurrency(discrepancy.rexCommission, 2)
              : '',
          },
          {
            columnConfig: columnConfig[7],
            children: discrepancy?.autopilotCommission
              ? formatCurrency(discrepancy.autopilotCommission, 2)
              : '',
          },
        ];

        return {
          cells: cells,
          id: `discrepancy-${index}`,
          isMobile: false,
        } satisfies TableRowProps;
      }),
    [discrepancies]
  );

  return [columnConfig, rows];
};

export default useCommissionDiscrepanciesTableConfig;
